/**
 * ImpersonationBanner - Shows when app is being viewed through user simulator
 *
 * Displays at the top of the app to indicate:
 * - The app is being viewed as another user
 * - Who the admin is impersonating
 * - All actions are logged
 */

import { useImpersonationStore } from '../../stores/impersonationStore';

export function ImpersonationBanner() {
  const { isImpersonated, targetUser, adminName, isValidating } = useImpersonationStore();

  // Don't show anything during validation or if not impersonated
  if (isValidating || !isImpersonated) {
    return null;
  }

  return (
    <div className="bg-amber-500 text-amber-900 px-4 py-2 text-center text-sm font-medium flex items-center justify-center gap-2 relative z-50">
      <svg className="w-4 h-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
      </svg>
      <span>
        <strong>Admin View:</strong>{' '}
        {adminName ? `${adminName} is` : 'You are'} viewing as{' '}
        <strong>{targetUser?.name || 'another user'}</strong>
        {targetUser?.role && ` (${targetUser.role})`}
        {' '}<span className="hidden sm:inline">- All actions are logged</span>
      </span>
    </div>
  );
}
